import { Component, OnInit } from '@angular/core';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';

@Component({
  selector: 'app-trigger-notification',
  templateUrl: './trigger-notification.component.html',
  styleUrls: ['./trigger-notification.component.scss']
})
export class TriggerNotificationComponent implements OnInit {


  triggerType: any = '';


  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private toast: ToastClientService
  ) { }

  ngOnInit() {
  }


  triggerNotification() {
    let sendApiUrl;
    if (this.triggerType == '' || this.triggerType == undefined) {
      this.toast.Error("Please Select Notification Type !!")
    } else if (this.triggerType) {
      if (this.triggerType == 'AdHoc Notification') {
        sendApiUrl = this.apiConfig.triggerAdhocNotification;
      } else if (this.triggerType == 'Engagement Reminder Notification') {
        sendApiUrl = this.apiConfig.triggerEngageRemNotification;
      } else if (this.triggerType == 'Target Reminder Notification') {
        sendApiUrl = this.apiConfig.triggerTargetRemNotification;
      } else if (this.triggerType == 'Scheme Reminder Notification') {
        sendApiUrl = this.apiConfig.triggerSchemeRemNotification;
      }

      this.apiService.get(sendApiUrl)
        .subscribe((res: any) => {
          if (res.status == 200) {
            this.toast.Success(res.data.message);
            this.triggerType = '';
          } else {
            this.toast.Error(res.data.message);
          }
        }, err => {

        })
    }

  }

}
